import BaseModel from '../core/BaseModel'
import PropertyTypeModel from '@/models/PropertyTypeModel'
export default class PropertyModel extends BaseModel {

    constructor() {
        super({
                name: "service",
                tableName: 'service',
                label: "Service management",
            display_key: 'name'
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                avatar: {
                    name: "avatar",
                    label: "Image",
                    custom: 'image',
                    type: "Computed",
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    //display: false,
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: 'Service name',
                    width: 15,
                    class:"small-col-midle ",
                    filter: {type: 'input', match: 'contains'},
                },
                available_from : {
                    name: 'available_from',
                    type: "Date",
                    label: 'Available from',
                    class:"small-col-midle ",
                    filter: { type: 'DateRange', match: 'contains'},
                    width: 8,
                },
                available_to : {
                    name: 'available_to',
                    type: "Date",
                    label: 'Available to',
                    class:"small-col-midle ",
                    filter: { type: 'DateRange', match: 'contains'},
                    width: 8,
                },
                type_of_price: {
                    name: "type_of_price",
                    label: "Type of price",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: '1', label: 'Price per days', style: 'color:  #000000;'},
                        {value: '2', label: 'Price per service',style: 'color:  #000000;'},
                        {value: '3', label: 'Need to confirm',style: 'color:  #000000;'},
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center txt-small-col-midle",
                    width: 8,
                },
                price_key: {
                    name: "price_key",
                    label: "Price from",
                    type: "Computed",
                    //width: 15,
                    //filter: {type: 'input', match: 'contains'},
                    class:"center txt-small-col-midle",
                    computed: (data) => {
                        data.price_key ='' ;
                    },
                    width: 8,
                },
                service_type_property_key: {
                    name:'service_type_property_key',
                    label:"Service type of property",
                    type: "Selection",
                    custom: 'SelectionText',
                    models: new PropertyTypeModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    class:"center txt-small-col-midle",
                    computed: (data) => {
                        data.service_type_property_key = '';
                    },
                    width: 8,
                },
                active: {
                    name: "active",
                    label: "Active",
                    type: "Selection",
                    custom: 'SelectionText',
                    options: [
                        {value: 'true', label: 'Yes', style: 'color:  #000000;'},
                        {value: 'false', label: 'No',style: 'color:  #000000;'}
                    ],
                    filter: {
                        type: 'select',
                        optionLabel: 'label',
                        optionKey: 'value',
                        match: 'equals'
                    },
                    class:"center xs-col",
                    width: 8,
                },
                updated_by_key: {
                    name: "updated_by_key",
                    label: "Updated by",
                    type: "Computed",
                    class:"small-col-midle ",
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.updated_by_key ='' ;
                    },
                    width: 8,
                },
                updated_at : {
                    name: 'updated_at',
                    type: "Datetime",
                    label: 'Updated date',
                    class:"small-col-midle ",
                    filter: { type: 'DateRange', match: 'contains'},
                    width: 8,
                },
                detail_get: {
                    refs:  'before_arrival_date obj_updated_by { id fullname }  lang_arr {id id_lang description id_service name} mandatory_arr{id service_id type_of_user_id auto_add_to_cart day_of_stay_more_than user_remove_it type_user}  ',
                    display: false
                },
                detail_get1: {
                    refs:  'active is_use_en need_assign time_to_finish sold_out ordinal type_of_property_arr{id service_id type_id price call_to_action_price obj_property_type{ name} }  ',
                    display: false
                },
            })
    }

}